import React from "react"
import {Card as AntdCard, Form} from "antd";
import Collapse from "../../../shared/display/collapse/Collapse";
import FilterBuilder from "../../../../utils/FilterBuilder";
import IContentType from "../../../../model/interface/dataStorage/IContentType";
import {IFilterBaseValue} from "../../../../utils/Filter/IFilterBase";
import IRestServiceFilters, {isFilterNested} from "../../../../model/interface/api/IRestServiceFilters";
import IViewFilterIslandItemSettings from "../../../../model/interface/dataStorage/view/settings/IViewFilterIslandItemSettings";
import IViewItem from "../../../../model/interface/dataStorage/view/IViewItem";
import IField from "../../../../model/interface/dataStorage/IField";
import IViewUnit from "../../../../model/interface/dataStorage/IViewUnit";
import {debounce} from "underscore";
import LocaleText from "../../settings/dictionary/LocaleText";


interface IState {
    values: IRestServiceFilters
}

interface IProps {
    filters?: IViewFilterIslandItemSettings[],
    defaultValues: IRestServiceFilters,
    viewUnit: IViewUnit,
    onChange: (filters: IRestServiceFilters, contentTypeUuid: string) => void
    collapsed?: boolean,
    contentType: IContentType
}

class ViewFilterIsland extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            values: props.defaultValues || {},
        }
        this.updateParent = debounce(this.updateParent, 800);
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
        if (this.props.defaultValues !== this.state.values && prevProps.defaultValues !== this.props.defaultValues) {
            this.setState({values: this.props.defaultValues});
        }
    }

    onFilterChange = (filters: IFilterBaseValue[], contentTypeUuid: string) => {
        const output: IRestServiceFilters = {}
        filters.forEach((filter, index) => {
            output[filter.name + index] = {
                field: filter.name,
                type: filter.type,
                value: filter.value,
                label: filter.label
            }
        })
        this.setState(state => ({values: {...state.values, ...output}}))
        this.updateParent(output, contentTypeUuid)
    }

    updateParent = (filters: IRestServiceFilters, contentTypeUuid: string) => {
        this.props.onChange(filters, contentTypeUuid)
    }

    render() {
        const {viewUnit, collapsed, contentType, filters} = this.props;
        const {values} = this.state

        const filterItems = filters
        let items: IViewItem[] = []
        if (filterItems) {
            filterItems?.forEach(filter => {
                const viewItem = viewUnit.items.find(i => i.field === filter.field  && filter.enabled && contentType.fields.some(f => f.uuid === i.field))
                if (viewItem) {
                    items.push(viewItem)
                }
            })
        }
        const defaultItems = collapsed ? false : items.filter(i => filterItems?.some(f => f.field === i.field && f.defaultVisible && f.enabled))
        items = defaultItems || items

        return items.length > 0 ? <Collapse collapsed={collapsed && !defaultItems}>
            <div className={'my-2'}>{viewUnit.contentTypes.length < 2 ?
                this.renderFilterCard(defaultItems || items, contentType, values) :
                <AntdCard key={contentType.uuid} size={"small"}
                          title={<LocaleText code={contentType.label || contentType.name}/>}>
                    {this.renderFilterCard(defaultItems || items, contentType, values)}
                </AntdCard>}
            </div>
        </Collapse> : <></>
    }

    renderFilterCard(items: IViewItem[], contentTypeObject: IContentType, filters: IRestServiceFilters) {
        return <>
            {items.map(item => {
                const field = contentTypeObject.fields.find(f => f.uuid === item.field)
                return field && <Form.Item label={<LocaleText code={item.label || field.label || ''}/>} key={item.uuid}>
                    {FilterBuilder.buildInput(item, field, this.getFilter(filters, contentTypeObject, field), (filters) => this.onFilterChange(filters, contentTypeObject.fullClassName))}
                </Form.Item>
            })}
        </>;
    }

    getFilter(filters: IRestServiceFilters, contentTypeObject: IContentType, field: IField) {
        let match: IFilterBaseValue[] = []
        Object.values(filters || {}).forEach(f => {
            if (!isFilterNested(f) && f.field === field.name) {
                match.push({...f, name: f.field})
            }
        })
        return match
    }
}

export default ViewFilterIsland